import { I18n } from '@calendly/i18n';
import { BodyText, LabelText, TitleText } from '@calendly/ui/components/typography';
import { Description } from 'components/event_type_edit';
import { useEventTypeContext } from 'features/event_type_provider';
import { AdditionalSettings } from './additional_settings';
import { CrudDuration } from './crud_duration';
import { CrudLocationChooser } from './crud_location_chooser';
import { GroupEventSection } from './group_event_section';
import { MeetingNameField } from './meeting_name_field';
const containerCss = "c1pzri4d";
const headerCss = "h17idg0j";
const sectionCss = "s1on3ka5";
const descriptionSectionCss = "dtu7xyv";
export const MeetingDetailsTab = ({
  etLocks = {},
  lockingDisables = false
}) => {
  const {
    eventType
  } = useEventTypeContext();
  const {
    isMETParent
  } = eventType;
  const isNameLocked = !isMETParent && etLocks.nameAndColor;
  const isLocationLocked = !isMETParent && etLocks.location;
  const isDurationLocked = !isMETParent && etLocks.duration;
  const isDescriptionLocked = !isMETParent && etLocks.description;
  const isGroupEventLocked = !isMETParent && etLocks.groupEvent;
  return <div className={containerCss} data-testid="meeting-details-tab">
      <div className={headerCss}>
        <TitleText size="large">
          {I18n.t('publisher.event_type_editor_crud.meeting_details.title')}
        </TitleText>
        <BodyText color="muted" size="large">
          {I18n.t('publisher.event_type_editor_crud.meeting_details.subtitle')}
        </BodyText>
      </div>

      <MeetingNameField isLocked={isNameLocked} />

      <div className={descriptionSectionCss}>
        <LabelText as="label" htmlFor="wysiwyg-description" size="large">
          {I18n.t('publisher.event_type_editor_crud.meeting_details.description_label')}
        </LabelText>
        <Description eventTypeId={eventType.id} isLocked={isDescriptionLocked} hideLabel />
      </div>

      <div className={sectionCss}>
        <LabelText as="h2" size="large">
          {I18n.t('publisher.event_types.location.location')}
        </LabelText>
        <CrudLocationChooser isLocked={isLocationLocked} isReadOnly={lockingDisables && isLocationLocked} />
      </div>

      <div className={sectionCss}>
        <LabelText as="h2" size="large">
          {I18n.t('publisher.event_types.availability.duration_fieldset.title')}
          {' *'}
        </LabelText>
        <CrudDuration isLocked={isDurationLocked} />
      </div>

      <GroupEventSection isLocked={isGroupEventLocked || lockingDisables} />

      <div className={sectionCss}>
        <AdditionalSettings isLocked={lockingDisables} />
      </div>
    </div>;
};

require("./meeting_details_tab.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meeting_details_tab.js");